class TimeoutError extends Error {
  type = 'timeout_error';
}

const timeoutPromise = (ms: number, msg: string) =>
  new Promise((_resolve, reject) =>
    setTimeout(() => reject(new TimeoutError(msg)), ms)
  );

export const timeoutAfter = <T extends unknown>(
  ms: number,
  timeoutMessage: string,
  promise: Promise<T>
) => {
  return Promise.race([timeoutPromise(ms, timeoutMessage), promise]);
};
